import moment from 'moment';
import {
  IDownloadNFEResponse,
  IFabricationOrder
} from '../../store/ducks/fabrication-orders/types';
import {
  customersAuthorizationApi,
  ECustomerAuthorizationEndpoints
} from '../api';
import { EGerdauService } from '../EGerdauService';

export class FabricationOrdersService extends EGerdauService {
  async getFabricationOrders(
    contractNumbers: string[],
    startDate: string,
    endDate: string
  ): Promise<IFabricationOrder[]> {
    const headers = super.getHeaders();

    const response = await customersAuthorizationApi.get(
      `${
        ECustomerAuthorizationEndpoints.FABRICATION_ORDER
      }?contractNumber=${contractNumbers.join(
        ','
      )}&startDate=${startDate}&endDate=${endDate}`,
      {
        headers: {
          ...headers,
          Accept: 'application/json'
        }
      }
    );
    const fabricationOrders: IFabricationOrder[] = response.data;

    this.sortFabricationOrdersBySendDateDesc(fabricationOrders);

    return fabricationOrders;
  }

  private sortFabricationOrdersBySendDateDesc(
    fabricationOrders: IFabricationOrder[]
  ) {
    const sortByIdDesc = () => {
      fabricationOrders.sort((a: IFabricationOrder, b: IFabricationOrder) => {
        return a.id < b.id ? 1 : a.id > b.id ? -1 : 0;
      });
    };
    sortByIdDesc();
    fabricationOrders.sort((a: IFabricationOrder, b: IFabricationOrder) => {
      const dateA = moment(a.sendDate, 'YYYY-MM-DD').toDate().getTime();
      const dateB = moment(b.sendDate, 'YYYY-MM-DD').toDate().getTime();
      return dateA < dateB ? 1 : dateA > dateB ? -1 : 0;
    });
  }

  async getFabricationOrderFromId(orderId: number): Promise<IFabricationOrder> {
    const headers = new FabricationOrdersService().getHeaders();

    const response = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.FABRICATION_ORDER}/${orderId}`,
      { headers }
    );

    try {
      const fabricationOrder: IFabricationOrder = response.data[0];
      return fabricationOrder;
    } catch (error) {
      throw new Error('Falha ao buscar o pedido.');
    }
  }

  async loadNFEFileFromFabricationOrderDelivery(
    danfeNumber: string
  ): Promise<IDownloadNFEResponse> {
    const headers = new EGerdauService().getHeaders();

    const response = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.GENERATE_BILLING}?docNum=${danfeNumber}&businessType=fabrication`,
      { headers }
    );

    return response.data as IDownloadNFEResponse;
  }
}
